import config from '@/config'

var style1 = document.createElement('style')
style1.innerHTML = `
body .van-button--primary {background-color: ${config.primaryColor};border-color: ${config.primaryColor};}
`
document.head.appendChild(style1)
